import { Search } from "@/src/svg/Search";
import { Menu } from "@/src/svg/Menu";
import { CloseBtn } from "@/src/svg/CloseBtn";
import AboutMhmbSvg from "../svg/navigation/main/AboutMhmbSvg";
import ProgramsSvg from "../svg/navigation/main/ProgramsSvg";
import AdmissionSvg from "../svg/navigation/main/AdmissionSvg";
import EducationSvg from "../svg/navigation/main/EducationSvg";
import AdvancedTrainingSvg from "../svg/navigation/main/AdvancedTrainingSvg";
import ContactSvg from "../svg/navigation/main/ContactSvg";
import FacultyMedicineSvg from "../svg/navigation/programs/FacultyMedicineSvg";
import FacultyArchitectureEngineeringSvg from "../svg/navigation/programs/FacultyArchitectureEngineeringSvg";
import FacultyBusinessSvg from "../svg/navigation/programs/FacultyBusinessSvg";
import FacultyITSvg from "../svg/navigation/programs/FacultyITSvg";
import FacultySocialHumanitarianSvg from "../svg/navigation/programs/FacultySocialHumanitarianSvg";
import FacultyLawSvg from "../svg/navigation/programs/FacultyLawSvg";
import AdmissionProcessFullTimeSvg from "../svg/navigation/admission/AdmissionProcessFullTimeSvg";
import AdmisisionProcessDistanceLearningSvg from "../svg/navigation/admission/AdmisisionProcessDistanceLearningSvg";
import EducationPersonalSvg from "../svg/navigation/education/EducationPersonalSvg";
import EducationRemotelySvg from "../svg/navigation/education/EducationRemotelySvg";
import AdvancedTrainingBookSvg from "../svg/navigation/advanced-training/AdvancedTrainingBookSvg";

export const headerCurrentPage = [
  { path: "/search", name: "Поиск" },
  { path: "/contact", name: "Контакты" },
  { path: "/profile", name: "Профиль" },
  { path: "/admissions", name: "Прием" },
  { path: "/apply-online", name: "Подача заявки онлайн и Статус" },
  /*--------------------------------------------------------------*/
  { path: "/programs", name: "Программы" },
  { path: "/programs/education-medical", name: "Факультет медицины" },
  { path: "/programs/education-business", name: "Факультет бизнеса" },
  { path: "/programs/education-sciences", name: "Факультет социально-гуманитарных наук" },
  { path: "/programs/education-technology", name: "Факультет IT" },
  { path: "/programs/education-arch", name: "Архитектурно-инженерный факультет" },
  { path: "/programs/education-law", name: "Факультет права" },
  /*--------------------------------------------------------------*/
  { path: "/single-programs", name: "Программа" },
  { path: "/single-programs/ambulance", name: "ФАКУЛЬТЕТ МЕДИЦИНЫ — СКОРАЯ ПОМОЩЬ" },
  {
    path: "/single-programs/anesthesiology-and-resuscitation",
    name: "ФАКУЛЬТЕТ МЕДИЦИНЫ — АНЕСТЕЗИОЛОГИЯ И РЕАНИМАТОЛОГИЯ",
  },
  { path: "/single-programs/cardiology", name: "ФАКУЛЬТЕТ МЕДИЦИНЫ — ОТОРИНОЛАРИНГОЛОГИЯ (ЛОР)" },
  {
    path: "/single-programs/clinical-psychology",
    name: "ФАКУЛЬТЕТ МЕДИЦИНЫ — КЛИНИЧЕСКАЯ ПСИХОЛОГИЯ",
  },
  { path: "/single-programs/dentistry", name: "ФАКУЛЬТЕТ МЕДИЦИНЫ — СТОМАТОЛОГИЯ" },
  { path: "/single-programs/dermatovenerology", name: "ФАКУЛЬТЕТ МЕДИЦИНЫ — ДЕРМАТОВЕНЕРОЛОГИЯ" },
  { path: "/single-programs/endocrinology", name: "ФАКУЛЬТЕТ МЕДИЦИНЫ — ЭНДОКРИНОЛОГИЯ" },
  { path: "/single-programs/family-medicine", name: "ФАКУЛЬТЕТ МЕДИЦИНЫ — СЕМЕЙНАЯ МЕДИЦИНА" },
  {
    path: "/single-programs/forensic-medical-examination",
    name: "ФАКУЛЬТЕТ МЕДИЦИНЫ — СУДЕБНО-МЕДИЦИНСКАЯ ЭКСПЕРТИЗА",
  },
  {
    path: "/single-programs/fundamental-medicine",
    name: "ФАКУЛЬТЕТ МЕДИЦИНЫ — ФУНДАМЕНТАЛЬНАЯ МЕДИЦИНА",
  },
  { path: "/single-programs/general-oncology", name: "ФАКУЛЬТЕТ МЕДИЦИНЫ — ОБЩАЯ ОНКОЛОГИЯ" },
  {
    path: "/single-programs/healthcare-management",
    name: "ФАКУЛЬТЕТ МЕДИЦИНЫ — МЕНЕДЖМЕНТ В ЗДРАВООХРАНЕНИИ (по направлениям)",
  },
  {
    path: "/single-programs/infectious-diseases",
    name: "ФАКУЛЬТЕТ МЕДИЦИНЫ — ИНФЕКЦИОННЫЕ ЗАБОЛЕВАНИЯ",
  },
  {
    path: "/single-programs/instumental-and-functional-methods-of-diagnostics",
    name: "ФАКУЛЬТЕТ МЕДИЦИНЫ — ИНСТРУМЕНТАЛЬНЫЕ И ФУНКЦИОНАЛЬНЫЕ МЕТОДЫ ДИАГНОСТИКИ",
  },
  {
    path: "/single-programs/medical-and-preventive-care",
    name: "ФАКУЛЬТЕТ МЕДИЦИНЫ — МЕДИКО-ПРОФИЛАКТИЧЕСКОЕ ДЕЛО",
  },
  { path: "/single-programs/medical-care", name: "ФАКУЛЬТЕТ МЕДИЦИНЫ — ЛЕЧЕБНОЕ ДЕЛО" },
  {
    path: "/single-programs/medical-pshychology",
    name: "ФАКУЛЬТЕТ МЕДИЦИНЫ – МЕДИЦИНСКАЯ ПСИХОЛОГИЯ",
  },
  { path: "/single-programs/morphology", name: "ФАКУЛЬТЕТ МЕДИЦИНЫ – МОРФОЛОГИЯ" },
  { path: "/single-programs/neurology", name: "ФАКУЛЬТЕТ МЕДИЦИНЫ – НЕВРОЛОГИЯ" },
  { path: "/single-programs/neurosurgery", name: "ФАКУЛЬТЕТ МЕДИЦИНЫ – НЕЙРОХИРУРГИЯ" },
  { path: "/single-programs/nursing", name: "ФАКУЛЬТЕТ МЕДИЦИНЫ – ВЫСШЕЕ МЕДСЕСТРИНСКОЕ ДЕЛО" },
  {
    path: "/single-programs/obstetrics-and-gynecology",
    name: "ФАКУЛЬТЕТ МЕДИЦИНЫ – АКУШЕРСТВО И ГИНЕКОЛОГИЯ",
  },
  { path: "/single-programs/ophthalmology", name: "ФАКУЛЬТЕТ МЕДИЦИНЫ – ОФТАЛЬМОЛОГИЯ" },
  {
    path: "/single-programs/otorhinolaryngology",
    name: "ФАКУЛЬТЕТ МЕДИЦИНЫ – ОТОРИНОЛАРИНГОЛОГИЯ (ЛОР)",
  },
  {
    path: "/single-programs/pathological-anatomy",
    name: "ФАКУЛЬТЕТ МЕДИЦИНЫ – ПАТОЛОГИЧЕСКАЯ АНАТОМИЯ",
  },
  { path: "/single-programs/pediatrics", name: "ФАКУЛЬТЕТ МЕДИЦИНЫ – ПЕДИАТРИЯ" },
  { path: "/single-programs/pharmacology", name: "ФАКУЛЬТЕТ МЕДИЦИНЫ – ФАРМАКОЛОГИЯ" },
  { path: "/single-programs/pharmacy", name: "ФАКУЛЬТЕТ МЕДИЦИНЫ – ФАРМАЦИЯ" },
  { path: "/single-programs/psychiatry", name: "ФАКУЛЬТЕТ МЕДИЦИНЫ – ПСИХИАТРИЯ" },
  { path: "/single-programs/surgery", name: "ФАКУЛЬТЕТ МЕДИЦИНЫ – ХИРУРГИЯ (по направлениям)" },
  { path: "/single-programs/therapy", name: "ФАКУЛЬТЕТ МЕДИЦИНЫ – ТЕРАПИЯ (по направлениям)" },
  { path: "/single-programs/traditional-medicine", name: "ФАКУЛЬТЕТ МЕДИЦИНЫ – НАРОДНАЯ МЕДИЦИНА" },
  {
    path: "/single-programs/traumatology-and-orthopedics",
    name: "ФАКУЛЬТЕТ МЕДИЦИНЫ – ТРАВМАТОЛОГИЯ И ОРТОПЕДИЯ",
  },
  { path: "/single-programs/urology", name: "ФАКУЛЬТЕТ МЕДИЦИНЫ – УРОЛОГИЯ" },
  /*-------------------------------*/
  {
    path: "/single-programs/accounting-and-auditing",
    name: "ФАКУЛЬТЕТ ЭКОНОМИКИ И УПРАВЛЕНИЯ – БУХГАЛТЕРСКИЙ УЧЕТ И АУДИТ",
  },
  { path: "/single-programs/banking", name: "ФАКУЛЬТЕТ БИЗНЕСА – БАНКОВСКОЕ ДЕЛО" },
  {
    path: "/single-programs/digital-marketing",
    name: "ФАКУЛЬТЕТ БИЗНЕСА И IT – ЦИФРОВОЙ МАРКЕТИНГ",
  },
  {
    path: "/single-programs/economics-of-enterprises-and-organizations",
    name: "ФАКУЛЬТЕТ БИЗНЕСА – ЭКОНОМИКА ПРЕДПРИЯТИЙ И ОРГАНИЗАЦИЙ",
  },
  {
    path: "/single-programs/entrepreneurship",
    name: "ФАКУЛЬТЕТ ЭКОНОМИКИ И УПРАВЛЕНИЯ – ПРЕДПРИНИМАТЕЛЬСТВО",
  },
  {
    path: "/single-programs/financial-management",
    name: "ФАКУЛЬТЕТ ЭКОНОМИКИ И УПРАВЛЕНИЯ – ФИНАНСОВЫЙ МЕНЕДЖМЕНТ",
  },
  {
    path: "/single-programs/international-business",
    name: "ФАКУЛЬТЕТ ЭКОНОМИКИ И УПРАВЛЕНИЯ – МЕЖДУНАРОДНЫЙ БИЗНЕС",
  },
  { path: "/single-programs/logistics", name: "ФАКУЛЬТЕТ БИЗНЕСА – ЛОГИСТИКА" },
  /*-------------------------------*/
  {
    path: "/single-programs/international-relations",
    name: "ФАКУЛЬТЕТ ПОЛИТИЧЕСКИХ НАУК — МЕЖДУНАРОДНЫЕ ОТНОШЕНИЯ",
  },
  {
    path: "/single-programs/journalism",
    name: "ФАКУЛЬТЕТ КОММУНИКАЦИЙ И СОЦИАЛЬНЫХ НАУК – ЖУРНАЛИСТИКА",
  },
  { path: "/single-programs/linguistics", name: "ФАКУЛЬТЕТ ГУМАНИТАРНЫХ НАУК – ЛИНГВИСТИКА" },
  {
    path: "/single-programs/media-and-digital-communications",
    name: "ФАКУЛЬТЕТ КОММУНИКАЦИЙ — МЕДИА И DIGITAL-КОММУНИКАЦИИ",
  },
  { path: "/single-programs/pedagogy", name: "ФАКУЛЬТЕТ ПЕДАГОГИКИ — ПЕДАГОГИКА" },
  { path: "/single-programs/psychology", name: "ФАКУЛЬТЕТ СОЦИАЛЬНЫХ НАУК – ПСИХОЛОГИЯ" },
  { path: "/single-programs/sociology", name: "ФАКУЛЬТЕТ СОЦИАЛЬНЫХ НАУК – СОЦИОЛОГИЯ" },
  /*-------------------------------*/
  {
    path: "/single-programs/artificial-intelligence",
    name: "ФАКУЛЬТЕТ ИТ И ИНЖЕНЕРИИ – ИСКУССТВЕННЫЙ ИНТЕЛЛЕКТ",
  },
  { path: "/single-programs/cybersecurity", name: "ФАКУЛЬТЕТ ИТ И ИНЖЕНЕРИИ – КИБЕРБЕЗОПАСНОСТЬ" },
  {
    path: "/single-programs/digital-transformation",
    name: "ФАКУЛЬТЕТ ИТ И ИНЖЕНЕРИИ – ЦИФРОВАЯ ТРАНСФОРМАЦИЯ",
  },
  {
    path: "/single-programs/game-and-multimedia-development",
    name: "ФАКУЛЬТЕТ ИСКУССТВА И ЦИФРОВЫХ ТЕХНОЛОГИЙ – РАЗРАБОТКА ИГР И МУЛЬТИМЕДИА",
  },
  {
    path: "/single-programs/information-systems",
    name: "ФАКУЛЬТЕТ ИТ И ИНЖЕНЕРИИ – ИНФОРМАЦИОННЫЕ СИСТЕМЫ",
  },
  {
    path: "/single-programs/network-technologies",
    name: "ФАКУЛЬТЕТ ИТ И ИНЖЕНЕРИИ – СЕТЕВЫЕ ТЕХНОЛОГИИ",
  },
  { path: "/single-programs/programming", name: "ФАКУЛЬТЕТ ИТ И ИНЖЕНЕРИИ – ПРОГРАММИРОВАНИЕ" },
  /*-------------------------------*/
  {
    path: "/single-programs/architectural-environment-design",
    name: "ФАКУЛЬТЕТ ИСКУССТВА И ДИЗАЙНА – ДИЗАЙН АРХИТЕКТУРНОЙ СРЕДЫ",
  },
  { path: "/single-programs/architecture", name: "ФАКУЛЬТЕТ АРХИТЕКТУРЫ – АРХИТЕКТУРА" },
  {
    path: "/single-programs/architecture-and-urban-planning",
    name: "ФАКУЛЬТЕТ ИСКУССТВА И ТЕХНОЛОГИЙ – АРХИТЕКТУРА И ГРАДОСТРОИТЕЛЬСТВО",
  },
  {
    path: "/single-programs/automotive-transport-maintenance",
    name: "ИНЖЕНЕРНЫЙ ФАКУЛЬТЕТ – ЭКСПЛУАТАЦИЯ АВТОМОБИЛЬНОГО ТРАНСПОРТА",
  },
  {
    path: "/single-programs/biomedical-engineering",
    name: "ИНЖЕНЕРНО-МЕДИЦИНСКИЙ ФАКУЛЬТЕТ – БИОМЕДИЦИНСКАЯ ИНЖЕНЕРИЯ",
  },
  {
    path: "/single-programs/building-engineering-and-maintenance",
    name: "ИНЖЕНЕРНЫЙ ФАКУЛЬТЕТ – ИНЖЕНЕРИЯ И ЭКСПЛУАТАЦИЯ ЗДАНИЙ И СООРУЖЕНИЙ",
  },
  {
    path: "/single-programs/civil-engineering",
    name: "ИНЖЕНЕРНЫЙ ФАКУЛЬТЕТ – СТРОИТЕЛЬНАЯ ИНЖЕНЕРИЯ",
  },
  {
    path: "/single-programs/construction-project-management",
    name: "ИНЖЕНЕРНО-СТРОИТЕЛЬНЫЙ ФАКУЛЬТЕТ – УПРАВЛЕНИЕ СТРОИТЕЛЬНЫМИ ПРОЕКТАМИ",
  },
  {
    path: "/single-programs/energy-and-water-supply-in-construction",
    name: "ИНЖЕНЕРНЫЙ ФАКУЛЬТЕТ – ЭНЕРГЕТИЧЕСКОЕ И ВОДОСНАБЖЕНИЕ В СТРОИТЕЛЬСТВЕ",
  },
  {
    path: "/single-programs/geodesy-and-land-management",
    name: "ИНЖЕНЕРНО-ГЕОГРАФИЧЕСКИЙ ФАКУЛЬТЕТ – ГЕОДЕЗИЯ И ЗЕМЛЕУСТРОЙСТВО",
  },
  {
    path: "/single-programs/oil-and-gas-engineering",
    name: "ЭНЕРГЕТИЧЕСКИЙ ФАКУЛЬТЕТ – НЕФТЕГАЗОВОЕ ДЕЛО",
  },
  {
    path: "/single-programs/railway-transport",
    name: "ТРАНСПОРТНЫЙ ФАКУЛЬТЕТ – ЖЕЛЕЗНОДОРОЖНЫЙ ТРАНСПОРТ",
  },
  /*-------------------------------*/
  { path: "/single-programs/civil-law", name: "ФАКУЛЬТЕТ ПРАВА — ГРАЖДАНСКОЕ ПРАВО" },
  { path: "/single-programs/corporate-law", name: "ФАКУЛЬТЕТ ПРАВА — КОРПОРАТИВНОЕ ПРАВО" },
  { path: "/single-programs/criminal-law", name: "ФАКУЛЬТЕТ ПРАВА — УГОЛОВНОЕ ПРАВО" },
  { path: "/single-programs/environmental-law", name: "ФАКУЛЬТЕТ ПРАВА — ЭКОЛОГИЧЕСКОЕ ПРАВО" },
  { path: "/single-programs/international-law", name: "ФАКУЛЬТЕТ ПРАВА — МЕЖДУНАРОДНОЕ ПРАВО" },
  { path: "/single-programs/labor-law", name: "ФАКУЛЬТЕТ ПРАВА — ТРУДОВОЕ ПРАВО" },
  {
    path: "/single-programs/law-in-the-digital-economy",
    name: "ФАКУЛЬТЕТ ПРАВА — ПРАВО В ЦИФРОВОЙ ЭКОНОМИКЕ",
  },
  /*--------------------------------------------------------------*/
  { path: "/single-page", name: "Single Page" },
  { path: "/single-page/about-university", name: "Об университете" },
  { path: "/single-page/our-advantages", name: "Наши преимущества" },
  { path: "/single-page/campus", name: "Кампус" },
  { path: "/single-page/admission-process-full-time", name: "Процесс поступления на очную форму" },
  {
    path: "/single-page/admisision-process-distance-learning",
    name: "Процесс поступления на дистанционную форму",
  },
  { path: "/single-page/education-personal", name: "Очное образование" },
  { path: "/single-page/education-remotely", name: "Дистанционное образование" },
  {
    path: "/single-page/modern-pedagogical-technologies",
    name: "Современные педагогические технологии",
  },
  { path: "/single-page/digitization-and-edtech", name: "Цифровизация и EdTech" },
  {
    path: "/single-page/international-cooperation-and-internationalization",
    name: "Международное сотрудничество и интернационализация",
  },
  {
    path: "/single-page/quality-and-academic-integrity",
    name: "КАЧЕСТВО И АКАДЕМИЧЕСКАЯ ДОБРОСОВЕСТНОСТЬ",
  },
  { path: "/single-page/medicine-and-healthcare", name: "МЕДИЦИНА И ЗДРАВООХРАНЕНИЕ" },
  {
    path: "/single-page/soft-skills-and-resources-of-the-teachet",
    name: "МЯГКИЕ НАВЫКИ И РЕСУРСНОСТЬ ПРЕПОДАВАТЕЛЯ",
  },
  {
    path: "/single-page/english-for-career-and-international-communication",
    name: "АНГЛИЙСКИЙ ДЛЯ КАРЬЕРЫ И МЕЖДУНАРОДНОГО ОБЩЕНИЯ",
  },
  {
    path: "/single-page/innovation-and-project-thinking-in-higher-education",
    name: "ИННОВАЦИИ И ПРОЕКТНОЕ МЫШЛЕНИЕ В ВЫСШЕМ ОБРАЗОВАНИИ",
  },
];
export const headerNavLinks = [
  {
    id: "about-mhmb",
    text: "Про MSMB",
    link: "/single-page/about-university",
    image: AboutMhmbSvg,
    submenu: [
      {
        id: "about-university",
        text: "Об университе",
        link: "/single-page/about-university",
        image: AboutMhmbSvg,
        description: "Современный международный вуз с сильной академической базой.",
      },
      {
        id: "our-advantages",
        text: "Наши преимущества",
        link: "/single-page/our-advantages",
        image: AboutMhmbSvg,
        description: "Качественное образование, практика за рубежом.",
      },
      {
        id: "campus",
        text: "Кампус",
        link: "/single-page/campus",
        image: AboutMhmbSvg,
        description: "Уютная студенческая среда с современной инфраструктурой.",
      },
    ],
  },
  {
    id: "programs",
    text: "Программы",
    link: "",
    image: ProgramsSvg,
    submenu: [
      {
        id: "programs-education-medical",
        text: "Факультет медицины",
        link: "/programs/education-medical",
        image: FacultyMedicineSvg,
        description: "Программы подготовки врачей и специалистов здравоохранения.",
      },
      {
        id: "programs-education-arch",
        text: "Архитектурно-инженерный факультет",
        link: "/programs/education-arch",
        image: FacultyArchitectureEngineeringSvg,
        description: "Обучение проектированию, строительным технологиям.",
      },
      {
        id: "programs-education-business",
        text: "Факультет бизнеса",
        link: "/programs/education-business",
        image: FacultyBusinessSvg,
        description: "Программы в области менеджмента, экономики и предпринимательства.",
      },
      {
        id: "programs-education-technology",
        text: "Факультет IT",
        link: "/programs/education-technology",
        image: FacultyITSvg,
        description: "Подготовка специалистов в сфере информационных технологий.",
      },
      {
        id: "programs-education-sciences",
        text: "Факультет социально-гуманитарных наук",
        link: "/programs/education-sciences",
        image: FacultySocialHumanitarianSvg,
        description: "Изучение общества, коммуникации, психологии.",
      },
      {
        id: "programs-education-law",
        text: "Факультет права",
        link: "/programs/education-law",
        image: FacultyLawSvg,
        description: "Юридическое образование, ориентированное на практику.",
      },
    ],
  },
  {
    id: "admission",
    text: "Поступление",
    link: "",
    image: AdmissionSvg,
    submenu: [
      {
        id: "admission-process-full-time",
        text: "Процесс поступления на очную форму",
        link: "/single-page/admission-process-full-time",
        image: AdmissionProcessFullTimeSvg,
        description: "Пошаговая система подачи документов и зачисления для обучения.",
      },
      {
        id: "admisision-process-distance-learning",
        text: "Процесс поступления на дистанционную форму",
        link: "/single-page/admisision-process-distance-learning",
        image: AdmisisionProcessDistanceLearningSvg,
        description: "Удобная форма подачи заявки и гибкое зачисление на онлайн.",
      },
    ],
  },
  {
    id: "education",
    text: "Обучение",
    link: "",
    image: EducationSvg,
    submenu: [
      {
        id: "education-personal",
        text: "Очное",
        link: "/single-page/education-personal",
        image: EducationPersonalSvg,
        description: "Учитесь в кампусе на Мальте и получайте международный диплом очно.",
      },
      {
        id: "education-remotely",
        text: "Дистанционно (онлайн)",
        link: "/single-page/education-remotely",
        image: EducationRemotelySvg,
        description: "Гибкий формат онлайн-обучения с международным дипломом.",
      },
    ],
  },
  {
    id: "advanced-training",
    text: "Повышение квалификации",
    link: "",
    image: AdvancedTrainingSvg,
    submenu: [
      {
        id: "modern-pedagogical-technologies",
        text: "Современные педагогические технологии",
        link: "/single-page/modern-pedagogical-technologies",
        image: AdvancedTrainingBookSvg,
        description: "Программы для преподавателей и цифровые подходы в обучении.",
      },
      {
        id: "digitization-and-edtech",
        text: "Цифровизация и EdTech",
        link: "/single-page/digitization-and-edtech",
        image: AdvancedTrainingBookSvg,
        description: "Подготовка специалистов к внедрению современных цифровых платформ.",
      },
      {
        id: "international-cooperation-and-internationalization",
        text: "Международное сотрудничество и интернационализация",
        link: "/single-page/international-cooperation-and-internationalization",
        image: AdvancedTrainingBookSvg,
        description: "Повышение квалификации в сфере глобального партнёрства.",
      },
      {
        id: "quality-and-academic-integrity",
        text: "Качество и академическая добросовестность",
        link: "/single-page/quality-and-academic-integrity",
        image: AdvancedTrainingBookSvg,
        description: "Программы, формирующие принципы этики, прозрачности.",
      },
      {
        id: "medicine-and-healthcare",
        text: "Медицина и здравоохранение",
        link: "/single-page/medicine-and-healthcare",
        image: AdvancedTrainingBookSvg,
        description: "Актуальные курсы для специалистов в сфере здоровья, профилактики.",
      },
      {
        id: "soft-skills-and-resources-of-the-teachet",
        text: "Мягкие навыки и ресурсность преподавателя",
        link: "/single-page/soft-skills-and-resources-of-the-teachet",
        image: AdvancedTrainingBookSvg,
        description: "Развитие гибких компетенций: коммуникации, адаптивности, лидерства.",
      },
      {
        id: "english-for-career-and-international-communication",
        text: "Английский для карьеры и международного общения",
        link: "/single-page/english-for-career-and-international-communication",
        image: AdvancedTrainingBookSvg,
        description: "Языковая подготовка для делового и академического общения в среде.",
      },
      {
        id: "innovation-and-project-thinking-in-higher-education",
        text: "Инновации и проектное мышление в высшем образовании",
        link: "/single-page/innovation-and-project-thinking-in-higher-education",
        image: AdvancedTrainingBookSvg,
        description: "Обучение применению инновационных подходов, дизайн-мышления. ",
      },
    ],
  },
  { id: "contacts", text: "Контакты", link: "/contact", image: ContactSvg },
];
export const headerTabsMenu = [
  {
    id: "search",
    icon: Search,
    activeIcon: CloseBtn,
    text: "Поиск",
  },
  {
    id: "menu",
    icon: Menu,
    activeIcon: CloseBtn,
    text: "Меню",
  },
];
